"use strict";
// Polyfills
require('core-js');
require('zone.js/dist/zone');
// Angular 2
require('angular2/platform/browser');
require('angular2/platform/common_dom');
require('angular2/core');



/*****************
 ** WEBPACK FOOTER
 ** ./src/vendor.ts
 ** module id = 0
 ** module chunks = 0
 **/